import { useEffect, useCallback } from 'react';

const INACTIVITY_TIMEOUT = 60 * 60 * 1000; // 1 hour in milliseconds

export function useSessionManager() {
  // Update last activity timestamp
  const updateActivity = useCallback(() => {
    localStorage.setItem('xyqar_last_activity', Date.now().toString());
  }, []);

  // Logout user (reload page)
  const logout = useCallback(() => {
    localStorage.removeItem('xyqar_last_activity');
    window.location.reload();
  }, []);

  // Check for inactivity
  const checkInactivity = useCallback(() => {
    const lastActivity = localStorage.getItem('xyqar_last_activity');
    if (lastActivity) {
      const timeSinceLastActivity = Date.now() - parseInt(lastActivity, 10);
      if (timeSinceLastActivity > INACTIVITY_TIMEOUT) {
        logout();
      }
    }
  }, [logout]);

  // Setup activity listeners
  useEffect(() => {
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    
    const handleActivity = () => {
      updateActivity();
    };

    // Add event listeners
    events.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    // Check inactivity every minute
    const inactivityInterval = setInterval(checkInactivity, 60 * 1000);

    // Set initial activity
    updateActivity();

    // Cleanup
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
      clearInterval(inactivityInterval);
    };
  }, [updateActivity, checkInactivity]);

  return {
    logout,
    updateActivity,
  };
}
